import { useQuery } from "@apollo/client";
import gql from "graphql-tag";

import { RootPermissions } from "gqlTypes";

const MY_PERMISSIONS_QUERY = gql`
  query MyPermissions {
    myPermissions {
      canClearCaches
      canSetAdminBanner
      canAdminSearch
      canExportRecords
      canImportRecords
      canCreateListings
      canViewNonPublicListings
      canViewSensitiveListings
      canAdministerListings
      canCreateOrganizations
      canCreateAdminUsers
      canCreateNonAdminUsers
      canAdmin
      canSuperadmin
    }
  }
`;

const useMyPermissions = () => {
  const { data, ...status } = useQuery<{ myPermissions: RootPermissions }>(MY_PERMISSIONS_QUERY);

  if (status.error) throw status.error;

  const permissions = data?.myPermissions ?? null;
  return [permissions, status] as const;
};

export default useMyPermissions;
